import { defineMessages } from '../../i18n/messages';
import { englishText } from '../../utils/messageFallbacks';

/*
 * Prose carried by the JSON-LD blocks in schemas.ts.
 *
 * Only the sentences are here. The product name reuses common.app_name and the plan names
 * reuse plan.name.* (component/common/PlanName.messages.ts) rather than being declared a
 * second time — they are the same strings the visible UI already shows, and one definition
 * keeps the structured data from disagreeing with the page.
 *
 * None of this is visible on the page: search engines read it, and use it as the snippet
 * under the result. That makes it worth translating, and worth keeping accurate.
 */
const SCHEMA_DEFINITIONS = {
  SOFTWARE_APPLICATION_DESCRIPTION: {
    id: 'seo.schema.software_application_description',
    text: 'AI-powered localization platform. Translate your app into 56 locales with one CLI command.',
    description:
      'Summary of the product published as schema.org SoftwareApplication structured data on the homepage, and used by search engines as the result snippet. "56" is the number of supported locales and "CLI" means command-line interface.',
  },
  PRODUCT_DESCRIPTION: {
    id: 'seo.schema.product_description',
    text: 'Developer-first localization platform with word-based pricing.',
    description:
      'Summary of the product published as schema.org Product structured data on the pricing page, and used by search engines as the result snippet. "word-based pricing" means customers are billed per translated word rather than per seat or per project.',
  },
  FREE_OFFER_DESCRIPTION: {
    id: 'seo.schema.free_offer_description',
    text: '5,000 words, no time limit, no credit card.',
    description:
      'Description of the free tier in the schema.org Offer list on the pricing page. Three clauses naming what the free plan gives: the word allowance, that it never expires, and that no payment details are needed. "5,000 words" is the allowance — format the number as your locale does.',
  },
};

export const SchemaMessages = defineMessages(SCHEMA_DEFINITIONS);

/** English fallbacks, used until `npm run lx:extract` adds these ids to en-US.json. */
export const SchemaText = englishText(SCHEMA_DEFINITIONS);
